import { Grid, makeStyles, Typography } from "@material-ui/core";
import BarChart from "../BarChart";
import BarChart2 from '../BarChart2'
import React from "react";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "30vw",
  },
  icon: {
    marginLeft: "15px",
  },
  datepickerRoot: {},
  root: {
    // backgroundColor: "#fff",
  },
  selectRoot: {
    backgroundColor: "#fff",
  },
  boxShadowOuter: {
    boxShadow: "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
    borderRadius: "5px",
    padding: "1vw",

    // height: "5vh",
  },
  countContainer: {
    boxShadow:"12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
    borderRadius: "5px",
    height: "18vh",
    padding: "1vw",
  },
  text: {
    fontFamily: "'Poppins', sansSerif",
    color: "#5A9BB7",
    fontWeight: "500",
    fontSize: "16px",
  },
  text2: {
    fontFamily: "'Poppins', sansSerif",
    fontWeight: "600",
    fontSize: "3vw",
  },
}));

export default function Overview(props) {
  const classes = useStyles();
  const {
    entryCount,
    totalVisitorsAllowedInside,
    insideFacility,
    peopleCount,
    count,
    lastThirtyDaysData,
  } = props;
  // const [joined,setJoined] = useState([0])
  // const [joined,setJoined] = useState([0])

  return (
    <div>
      <Grid container spacing={3}>
        <Grid container lg={6} item>
          <Grid container spacing={3}>
            <Grid container item lg={6}>
              <Grid
                container
                className={classes.countContainer}
                alignItems="center"
                style={{ paddingTop: "0px", paddingRight: "0px" }}
              >
                <Grid container lg={8}>
                  <Grid container>
                  <Typography className={classes.text}>
                    Inside 
                  </Typography>
                  </Grid>
                  <Grid container>
                  <Typography className={classes.text}>
                    facility
                  </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  lg={4}
                  justify="center"
                  alignItems="center"
                  style={{
                    boxShadow: "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
                    borderRadius: "5px",
                    padding: "3px",
                    height: "4vw",
                  }}
                >
                  <Typography
                    style={{
                      fontWeight: "600",
                      color: "#22FCA8",
                      fontFamily: "'Poppins', sansSerif",
                      fontSize: "21px",
                    }}
                  >
                    {totalVisitorsAllowedInside ? totalVisitorsAllowedInside :0}
                  </Typography>
                </Grid>
                <Grid container>
                  <Typography>
                    <Typography
                      className={classes.text2}
                      style={{ color: totalVisitorsAllowedInside ? insideFacility >  totalVisitorsAllowedInside ? "#FF4183" : "#22FCA8" : "#22FCA8"}}
                    >
                      {insideFacility ? insideFacility : 0}
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item lg={6}>
              <Grid
                container
                className={classes.countContainer}
                alignItems="center"
              >
                <Grid container>
                  <Typography className={classes.text}>
                    Total 
                  </Typography>
                  </Grid>
                  <Grid container>
                  <Typography className={classes.text}>
                    joined
                  </Typography>
                  </Grid>
                <Grid container>
                  <Typography>
                    <Typography
                      className={classes.text2}
                      style={{ color: "#5ADFFE" }}
                    >
                      {count ? count : 0}
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item lg={6}>
              <Grid
                container
                className={classes.countContainer}
                alignItems="center"
              >
                <Grid container>
                  <Typography className={classes.text}>
                    Total 
                  </Typography>
                  </Grid>
                  <Grid container>
                  <Typography className={classes.text}>
                    visitors
                  </Typography>
                  </Grid>
                <Grid container>
                  <Typography>
                    <Typography
                      className={classes.text2}
                      style={{ color: "#22FCA8" }}
                    >
                      {peopleCount ? peopleCount : 0}
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item lg={6}>
              <Grid
                container
                className={classes.countContainer}
                alignItems="center"
              >
               <Grid container>
                  <Typography className={classes.text}>
                    Total 
                  </Typography>
                  </Grid>
                  <Grid container>
                  <Typography className={classes.text}>
                    standing
                  </Typography>
                  </Grid>
                <Grid container>
                  <Typography>
                    <Typography
                      className={classes.text2}
                      style={{ color: "#FD95C9" }}
                    >
                      {peopleCount ? peopleCount - entryCount : 0}
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item lg={6}>
              <Grid
                container
                className={classes.countContainer}
                alignItems="center"
              >
                <Grid container>
                  <Typography className={classes.text}>
                    Total 
                  </Typography>
                  </Grid>
                  <Grid container>
                  <Typography className={classes.text}>
                    entered
                  </Typography>
                  </Grid>
                <Grid container>
                  <Typography>
                    <Typography
                      className={classes.text2}
                      style={{ color: "#5F96FF" }}
                    >
                      {entryCount ? entryCount : 0}
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item lg={6}>
              <Grid
                container
                className={classes.countContainer}
                alignItems="center"
              >
                <Grid container>
                  <Typography className={classes.text}>
                    Total 
                  </Typography>
                  </Grid>
                  <Grid container>
                  <Typography className={classes.text}>
                    exited
                  </Typography>
                  </Grid>
                <Grid container>
                  <Typography>
                    <Typography
                      className={classes.text2}
                      style={{ color: "#FF4183" }}
                    >
                      {entryCount ? entryCount - insideFacility : 0}
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container lg={6} item>
          <Grid
            container
            style={{
              width: "100%",
              boxShadow: "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
              borderRadius: "5px",
              padding: "2vw",
              marginRight:"5vw",
              paddingTop: "1vw",
            }}
          >
            <Grid container lg={6}>
              <Typography className={classes.text}>
                Visitors by status
              </Typography>
            </Grid>
            <Grid container lg={6} direction="row-reverse">
              <Typography className={classes.text}>Last 30 days</Typography>
            </Grid>
            <BarChart
              // label={overview.map((data) => data[0].date)}
              // registered={overview.map((data) => data[0].peopleCount)}
              // entryScan={overview.map((data) => data[0].entryCount)}
              // lastThirtyDaysData={lastThirtyDaysData}
              label={lastThirtyDaysData.map((data) => data.date)}
              joined={lastThirtyDaysData.map((data) => data.joined)}
              visited={lastThirtyDaysData.map((data) => data.visited)}
              cancelled={lastThirtyDaysData.map((data) => data.cancelled)}
              notVisited={lastThirtyDaysData.map((data) => data.notVisited)}
            />
          </Grid>
        </Grid>

        <Grid container lg={6} item>
          <Grid
            container
            style={{
              width: "100%",
              boxShadow:"12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
              borderRadius: "5px",
              padding: "2vw",
              paddingTop: "1vw",
            }}
          >
            <Grid container>
              <Typography className={classes.text}>Visitors By Days</Typography>
            </Grid> 
             {/* <BarChart2
              monday={async () => {
                var visited = 0;
                const mondayArray = lastThirtyDaysData.filter(
                  (data) => data.day === "Monday"
                );
                const values = mondayArray.map((d) => d.visited);
                if (values.length > 0) {
                  visited = values.reduce((a,b) => a + b);
                }
                return visited;
              }}
              tuesday={async () => {
                var visited = 0;
                const mondayArray = lastThirtyDaysData.filter(
                  (data) => data.day === "Tuesday"
                );
                const values = mondayArray.map((d) => d.visited);
                if (values.length > 0) {
                  visited = values.reduce((a,b) => a + b);
                }
                return visited;
              }}
              wednesday={async () => {
                var visited = 0;
                const mondayArray = lastThirtyDaysData.filter(
                  (data) => data.day === "Wednesday"
                );
                const values = mondayArray.map((d) => d.visited);
                if (values.length > 0) {
                  visited = values.reduce((a,b) => a + b);
                }
                return visited;
              }}
              thursday={async () => {
                var visited = 0;
                const mondayArray = lastThirtyDaysData.filter(
                  (data) => data.day === "Thursday"
                );
                const values = mondayArray.map((d) => d.visited);
                if (values.length > 0) {
                  visited = values.reduce((a,b) => a + b);
                }
                return visited;
              }}
              friday={async () => {
                var visited = 0;
                const mondayArray = lastThirtyDaysData.filter(
                  (data) => data.day === "Friday"
                );
                const values = mondayArray.map((d) => d.visited);
                if (values.length > 0) {
                  visited = values.reduce((a,b) => a + b);
                }
                return visited;
              }}
              saturday={async () => {
                var visited = 0;
                const mondayArray = lastThirtyDaysData.filter(
                  (data) => data.day === "Saturday"
                );
                const values = mondayArray.map((d) => d.visited);
                if (values.length > 0) {
                  visited = values.reduce((a,b) => a + b);
                }
                return visited;
              }}
              sunday={async () => {
                var visited = 0;
                const mondayArray = lastThirtyDaysData.filter(
                  (data) => data.day === "Sunday"
                );
                const values = mondayArray.map((d) => d.visited);
                if (values.length > 0) {
                  visited = values.reduce((a,b) => a + b);
                }
                return visited;
              }} */}
              {Object.keys(lastThirtyDaysData).length >0 ? <BarChart2
                lastThirtyDaysData={lastThirtyDaysData}
              />: null }
            
          </Grid> 
         </Grid> 
      </Grid>
    </div>
  );
}
